import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { largeBreakpoint } from "config/media";

import ItemDetails from "./ItemDetails";
import Tabs from "components/../react/components/Tabs";
import ChargesPaid from "./ChargesPaid";

const PaymentDetails = ({ item }) => {
  const tabs = [
    { name: "Details", tab: <ItemDetails item={item} /> },
    { name: "Charges Paid", tab: <ChargesPaid item={item} /> },
  ];

  const [currentTab, setTab] = useState(tabs[0].name);

  return (
    <>
      <PaymentDetailTabs
        tabs={tabs.map((tab) => tab.name)}
        current={currentTab}
        setTab={setTab}
        testid="payment-details-tabs"
      />
      {tabs.find((tab) => tab.name === currentTab).tab}
    </>
  );
};
PaymentDetails.displayName = "PaymentDetails";
PaymentDetails.propTypes = {
  item: PropTypes.object,
};
export default PaymentDetails;

export const PaymentDetailTabs = styled(Tabs)`
  @media all and (max-width: ${largeBreakpoint}px) {
    li {
      margin: 0;
      padding: 0;
      text-align: center;
      width: 49%;
    }
  }
`;
